import type { LanguageTexts } from './types';

export const de: LanguageTexts = {
  consentTitle: 'Cookies auf dieser Website',
  consentDescription:
    'Wir verwenden notwendige Cookies, ohne die die Website nicht funktioniert. Mit Ihrer Einwilligung würden wir auch Cookies für {purposes} verwenden, einschließlich Cookies von Drittanbietern. Sie können Ihre Auswahl jederzeit über die Schaltfläche in der unteren Ecke der Seite ändern oder widerrufen.',
  consentDescriptionNecessaryOnly:
    'Wir verwenden nur notwendige Cookies, ohne die die Website nicht funktioniert. Dafür ist keine Einwilligung erforderlich.',
  controllerLine: 'Verantwortlicher: {controller}.',
  acceptAll: 'Alle akzeptieren',
  rejectAll: 'Alle ablehnen',
  preferences: 'Einstellungen',
  save: 'Auswahl speichern',
  close: 'Schließen',
  serviceCounter: 'Dienst|Dienste',
  preferencesTitle: 'Cookie-Einstellungen',
  introTitle: 'Wie wir Cookies verwenden',
  introDescription:
    'Cookies sind kleine Dateien, die eine Website in Ihrem Browser speichert. Wählen Sie unten, welche Sie zulassen. Notwendige Cookies sind immer aktiv.',
  necessaryTitle: 'Notwendige Cookies',
  necessaryDescription:
    'Erforderlich für den sicheren Betrieb der Website und um Ihre Cookie-Auswahl zu speichern. Dafür ist keine Einwilligung erforderlich.',
  categories: {
    functional: {
      title: 'Funktionale Cookies',
      description: 'Ermöglichen zusätzliche Funktionen, zum Beispiel eingebettete Karten und gespeicherte Einstellungen.',
      purpose: 'zusätzliche Funktionen',
    },
    analytics: {
      title: 'Analyse-Cookies',
      description:
        'Helfen uns zu verstehen, wie Besucher die Website nutzen (zum Beispiel, welche Seiten am häufigsten besucht werden), damit wir sie verbessern können.',
      purpose: 'Besuchsmessung',
    },
    marketing: {
      title: 'Werbe-Cookies',
      description:
        'Werden von Werbepartnern und Anbietern eingebetteter Inhalte (zum Beispiel Videos) verwendet, um relevantere Werbung zu zeigen und deren Erfolg zu messen. Sie können Ihre Besuche auf anderen Websites verfolgen.',
      purpose: 'Werbung',
    },
  },
  moreTitle: 'Weitere Informationen',
  moreDescription: 'Mehr über Cookies und Ihre Rechte erfahren Sie in unserer {policyLink}.',
  policyLinkText: 'Cookie-Richtlinie',
  policyTitle: 'Cookie-Richtlinie',
  and: 'und',
  poweredBy: 'Bereitgestellt von',
  revisitLabel: 'Cookie-Einstellungen',
  iframeNotice: 'Für diesen Inhalt ist eine Einwilligung in „{category}“ erforderlich.',
  iframeButton: 'Zulassen und anzeigen',
  tableName: 'Cookie',
  tableProvider: 'Anbieter',
  tablePurpose: 'Zweck',
  tableDuration: 'Dauer',
  session: 'Sitzung',
  consentCookiePurpose: 'Speichert Ihre Cookie-Auswahl.',
  otherCookiesTitle: 'Weitere Cookies',
  otherCookiesNote: 'Cookies dieser Website, die Kockica nicht erkennt. Wenden Sie sich für Details an den Verantwortlichen.',
  noCookies: 'Auf dieser Seite wurden keine einwilligungspflichtigen Cookies erkannt.',
};
